module.exports = __webpack_public_path__ + "static/media/phone.464a4070.svg";